<div class="row">
     <div class="col-12">
          <div class="row justify-content-between align-items-center" id="page-title">
               <h1 class="progress-header col-12 col-lg-auto" [innerHTML]="'Enroll in PSP_MAIN'  | translator:'base'">
                    Enroll in PSP</h1>
          </div>
          <div class="row mb-2">
               <span class="col-12 col-lg-auto d-flex align-items-center small">
                    <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                    <span [innerHTML]="'Start_8-1' | translator:'base'">
                         Are you a <strong>driver</strong> looking for your own PSP record?
                    </span>
                    <a routerLink="/driver/1" (click)="scrollToTop()" name="Driver-record-request"
                         id="Driver-record-request" [title]="'Start_8-2'  | translator:'base'" class="ms-1">
                         <span [innerHTML]="'Start_8-2'  | translator:'base'">Access your PSP record
                              here.</span>
                    </a>
               </span>
          </div>
          <div class="row">
               <div class="col-lg-8">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <app-complete-bar [step]="17" [totalSteps]="19"></app-complete-bar>
                              
                              <h2 [innerHTML]="'Payment_1'  | translator:'base'">JUST ONE MORE DETAIL</h2>
                              <p><strong [innerHTML]="'Payment_4'  | translator:'base'">You need to agree to the
                                        following terms and conditions.</strong></p>
                              <ul>
                                   <li [innerHTML]="'Payment_5'  | translator:'base'">Click the "I have read and agree"
                                        box below.</li>
                                   <li [innerHTML]="'Payment_6'  | translator:'base'">Enter your full name and title;
                                        and</li>
                                   <li [innerHTML]="'Payment_7'  | translator:'base'">Click 'Submit Application' button
                                        to finish your application process.</li>
                              </ul>
                              <hr>
                              <p *ngIf="enrollmentService.newCustomer!.customerType == customerType.AH"
                                   [innerHTML]="'Payment_8'  | translator:'base'">
                                   By my submitting this application on behalf of the Monthly Account Holder I agree
                                   that:
                              </p>
                              <p *ngIf="enrollmentService.newCustomer!.customerType == customerType.ISP"
                                   [innerHTML]="'Payment_8_ISP'  | translator:'base'">
                                   By my submitting this application on behalf of the Industry Service Provider I agree
                                   that:
                              </p>
                              <ol>
                                   <li *ngIf="enrollmentService.newCustomer!.customerType == customerType.AH"
                                        [innerHTML]="'Payment_9'  | translator:'base'">
                                        I have read and, on behalf of the Monthly Account Holder, agree to the terms and
                                        conditions of NIC Federal's Monthly Account Holder Agreement as presented.
                                   </li>
                                   <li *ngIf="enrollmentService.newCustomer!.customerType == customerType.AH"
                                        [innerHTML]="'Payment_10'  | translator:'base'">
                                        I represent that I have authority to bind the Monthly Account Holder, on whose
                                        behalf I am signing, to this Agreement.
                                   </li>
                                   <li *ngIf="enrollmentService.newCustomer!.customerType == customerType.AH"
                                        [innerHTML]="'Payment_11'  | translator:'base'">
                                        I have read and understand, and the Monthly Account Holder agrees to be bound by
                                        and comply with, the Limitations on Use of Information and the Fair Credit
                                        Reporting Act requirements.
                                   </li>
                                   <li *ngIf="enrollmentService.newCustomer!.customerType == customerType.AH"
                                        [innerHTML]="'Payment_12'  | translator:'base'">
                                        Monthly Account Holder will obtain and preserve the written disclosure and
                                        authorization of each Applicant prior to accessing the Applicant's information
                                        on the PSP service, using the exact, stand-alone FMCSA-required document
                                        provided as part of this Agreement.
                                   </li>
                                   <li *ngIf="enrollmentService.newCustomer!.customerType == customerType.ISP"
                                        [innerHTML]="'Payment_9_ISP'  | translator:'base'">
                                        I have read and, on behalf of the Industry Service Provider, agree to the terms
                                        and conditions of NIC Federal's Industry Service Provider Agreement as
                                        presented.
                                   </li>
                                   <li *ngIf="enrollmentService.newCustomer!.customerType == customerType.ISP"
                                        [innerHTML]="'Payment_10_ISP'  | translator:'base'">
                                        I represent that I have authority to bind the Industry Service Provider, on
                                        whose behalf I am signing, to this Agreement.
                                   </li>
                                   <li *ngIf="enrollmentService.newCustomer!.customerType == customerType.ISP">
                                        <span Payment_11_ISP
                                        [innerHTML]="'Payment_11_ISP'  | translator:'base'">
                                        I have read and understand, and the Industry Service Provider agrees to be bound
                                        by and comply with, the Limitations on Use of Information and the Fair Credit
                                        Reporting Act requirements.</span>
                                        <ul class="ms-4 mt-2" style="list-style: none; padding-left: 0;">
                                             <li>
                                                  <span>3.a. </span>
                                                  <span [innerHTML]="'Payment_11_ISP_3a' | translator:'base'">
                                                       I understand any work outside of the authority as defined by the Industry Service Provider, the Information may be used for the sole purpose of pre-employment screening and not used for other areas of my organization’s work.
                                                  </span>
                                             </li>
                                        </ul>
                                   </li>
                                   <li *ngIf="enrollmentService.newCustomer!.customerType == customerType.ISP"
                                        [innerHTML]="'Payment_12_ISP'  | translator:'base'">
                                        Industry Service Provider will obtain and preserve the written disclosure and
                                        authorization of each Applicant prior to accessing the Applicant's information
                                        on the PSP service, using the exact, stand-alone FMCSA-required document
                                        provided as part of this Agreement.
                                   </li>
                              </ol>
                              <hr>
                              <fieldset>
                                   <div class="form-check">
                                        <label class="form-check-label">
                                             <input 
                                                  type="radio" 
                                                  id="agreeReadAgreement22" 
                                                  name="agreesToConsent" 
                                                  class="form-check-input" 
                                                  value="agree"
                                                  [(ngModel)]="enrollmentService.newCustomer!.finalConsent!.agreesToConsent" 
                                             >
                                             <span [innerHTML]="'Payment_13'  | translator:'base'">I have read and agree
                                                  to these terms and conditions and am authorized to sign on behalf of
                                                  the monthly account holder.</span>
                                        </label>
                                   </div>
                                   <div class="form-check mb-3">
                                        <label class="form-check-label">
                                             <input 
                                                  type="radio"
                                                  id="disagreeReadAgreement22" 
                                                  name="agreesToConsent"
                                                  class="form-check-input" 
                                                  value="disAgree" 
                                                  [(ngModel)]="enrollmentService.newCustomer!.finalConsent!.agreesToConsent"
                                             >
                                             <span [innerHTML]="'Payment_14'  | translator:'base'">I disagree with these
                                                  terms and conditions.</span>
                                        </label>
                                   </div>
                                   <div class="row gx-2" [formGroup]="companyInfo">
                                        <div class="col-md-4 pe-3 pe-md-2 mb-3 mb-md-0">
                                             <label for="AgentFirstName" class="form-label">
                                                  <span [innerHTML]="'FirstName'  | translator:'base'">First
                                                       Name</span>
                                                  <span class="text-danger text-center ms-1"
                                                       [title]="'Required'  | translator:'base'">*</span>
                                             </label>
                                             <input type="text" class="form-control bg-light"
                                                  id="AgentFirstName" name="AgentFirstName"
                                                  formControlName="firstName" [readonly]="enrollmentService.newCustomer!.finalConsent?.agreesToConsent !== 'agree'"  maxlength="10">
                                             <div *ngIf="agentFirstName!.invalid && agentFirstName!.dirty"
                                                  class="help-block text-danger">
                                                  <div *ngIf="agentFirstName!.errors?.['required']"
                                                       [innerHTML]="'AgentFirstName_required' | translator:'base'">
                                                  </div>
                                                  <div *ngIf="agentFirstName!.errors?.['maxlength']"
                                                       [innerHTML]="'AgentFirstName_max' | translator:'base'">
                                                  </div>
                                                  <div *ngIf="agentFirstName!.errors?.['pattern']"
                                                       [innerHTML]="'agentFirstName_invalid' | translator:'base'">
                                                  </div>
                                             </div>

                                        </div>
                                        <div class="col-md-4 px-3 px-md-2 mb-3 mb-md-0">
                                             <label for="AgentLastName" class="form-label">
                                                  <span [innerHTML]="'LastName'  | translator:'base'">Last Name</span>
                                                  <span class="text-danger text-center ms-1"
                                                       [title]="'Required'  | translator:'base'">*</span>
                                             </label>
                                             <input name="AgentLastName" type="text" class="form-control bg-light" [readonly]="enrollmentService.newCustomer!.finalConsent?.agreesToConsent !== 'agree'"
                                                  id="AgentLastName" formControlName="lastName" maxlength="20">
                                             <div *ngIf="agentLastName!.invalid && agentLastName!.dirty"
                                                  class="help-block text-danger">
                                                  <div *ngIf="agentLastName!.errors?.['required']"
                                                       [innerHTML]="'agentLastName_required' | translator:'base'">
                                                  </div>
                                                  <div *ngIf="agentLastName!.errors?.['maxlength']"
                                                       [innerHTML]="'agentLastName_max' | translator:'base'">
                                                  </div>
                                                  <div *ngIf="agentLastName!.errors?.['pattern']"
                                                       [innerHTML]="'agentLastName_invalid' | translator:'base'">
                                                  </div>
                                             </div>

                                        </div>
                                        <div class="col-md-4 ps-3 ps-md-2 mb-md-0">
                                             <div class="form-group">
                                                  <label for="AgentTitle" class="form-label">
                                                       <span [innerHTML]="'Title'  | translator:'base'">Title</span>
                                                       <span class="text-danger text-center ms-1"
                                                            [title]="'Required'  | translator:'base'">*</span>
                                                  </label>
                                                  <input name="AgentTitle" type="text" class="form-control bg-light" [readonly]="enrollmentService.newCustomer!.finalConsent?.agreesToConsent !== 'agree'"
                                                       id="AgentTitle" formControlName="title"  maxlength="25">
                                                  <div *ngIf="agentTitle!.invalid && agentTitle!.dirty"
                                                       class="help-block text-danger">
                                                       <div *ngIf="agentTitle!.errors?.['required']"
                                                            [innerHTML]="'agentTitle_required' | translator:'base'">
                                                       </div>
                                                       <div *ngIf="agentTitle!.errors?.['maxlength']"
                                                            [innerHTML]="'agentTitle_max' | translator:'base'">
                                                       </div>
                                                       <div *ngIf="agentTitle!.errors?.['pattern']"
                                                            [innerHTML]="'agentTitle_invalid' | translator:'base'">
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </fieldset>
                              <div class="d-flex flex-row-reverse justify-content-between mt-4 btn-group-wizard-submit">
                                   <div class="btn-group" role="group">
                                        <button (click)="completeEnrollment()" [disabled]="!pageValid() || isSubmitted"
                                             class="btn btn-primary btn-strong"
                                             [title]="'Payment_15'  | translator:'base'" name="companyNext22"
                                             id="companyNext22">
                                             <span [innerHTML]="'Payment_15'  | translator:'base'">Submit
                                                  Application</span>
                                        </button>
                                   </div>
                                   <div class="btn-group" role="group">
                                        <a routerLink="/signup/20" tag="button" (click)="scrollToTop()"
                                             class="btn btn-outline-primary" [title]="'Payment_16'  | translator:'base'"
                                             name="companyBack22" id="companyBack22">
                                             <span [innerHTML]="'Back'  | translator:'base'">Back</span>
                                             <span class="sr-only">&nbsp;</span>
                                             <span class="sr-only"
                                                  [innerHTML]="'Payment_16'  | translator:'base'">Certifications</span>
                                        </a>
                                        <a routerLink="/" tag="button" class="btn btn-light" (click)="scrollToTop()"
                                             name="companyCancel22" id="companyCancel22"
                                             [innerHTML]="'Cancel'  | translator:'base'"
                                             [title]="'Cancel'  | translator:'base'">
                                             Cancel
                                        </a>
                                   </div>
                              </div>
                              <div class="overlay" *ngIf="isSubmitted">
                                   <h1 class="heading" [innerHTML]="'Processing'  | translator:'base'">Processing...
                                   </h1>
                                   <img [alt]="'Processing'  | translator:'base'" />
                              </div>
                         </div>
                    </div>
               </div>
               <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="6"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
          </div>
     </div>
     <app-spinner
          [isLoading] = isLoading
     ></app-spinner>
</div>